import request from '@/utils/server'
// 新增
  export function getCheckData(query) {
    return request({
      url: '/device/morningChecker/getCheckData',    
      method: 'get',
      params: query
    })
  }
